// Theme configuration loaded after DOM ready
(function() {
  // Shopify config
  window.shopUrl = window.shopUrl || '';
  window.routes = window.routes || {};
  window.cartStrings = window.cartStrings || {};
  window.variantStrings = window.variantStrings || {};
  window.accessibilityStrings = window.accessibilityStrings || {};
  
  // External links handler
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  
  console.log('AURA VINYL');
})();


